import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const isAllowActivity = (
    state: IApplicationState,
): boolean => {
    const { allowActivity } = getAuthUser(state);
    return allowActivity;
};
